/**
 * Per-day token consumption: prompt vs completion stacked bars. Palette
 * validated with the dataviz six-checks validator for both modes (light
 * aqua sits at 2.7:1 vs surface — relief carried by the legend, tooltips,
 * and the per-user table below).
 */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Bar, BarChart, Card, CardContent, CardHeader, CardTitle, CartesianGrid, ChartContainer, ChartLegend, ChartLegendContent, ChartTooltip, ChartTooltipContent, XAxis, YAxis } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { formatTokens } from './hooks';
const chartConfig = {
    prompt: {
        label: 'Prompt tokens',
        theme: {
            light: '#2a78d6',
            dark: '#3987e5'
        }
    },
    completion: {
        label: 'Completion tokens',
        theme: {
            light: '#1baf7a',
            dark: '#199e70'
        }
    }
};
export function UsageChart({ days }) {
    const data = days.map((d)=>({
            day: d.day,
            prompt: Number(d.totals?.promptTokens ?? 0),
            completion: Number(d.totals?.completionTokens ?? 0)
        }));
    return /*#__PURE__*/ _jsxs(Card, {
        children: [
            /*#__PURE__*/ _jsx(CardHeader, {
                children: /*#__PURE__*/ _jsx(CardTitle, {
                    className: "text-base",
                    children: "Tokens per day"
                })
            }),
            /*#__PURE__*/ _jsx(CardContent, {
                "data-testid": Testids.adminUsage.chart,
                children: data.length === 0 ? /*#__PURE__*/ _jsx("p", {
                    className: "py-10 text-center text-sm text-muted-foreground",
                    children: "No usage recorded in this range yet."
                }) : /*#__PURE__*/ _jsx(ChartContainer, {
                    config: chartConfig,
                    className: "h-64 w-full",
                    children: /*#__PURE__*/ _jsxs(BarChart, {
                        data: data,
                        children: [
                            /*#__PURE__*/ _jsx(CartesianGrid, {
                                vertical: false
                            }),
                            /*#__PURE__*/ _jsx(XAxis, {
                                dataKey: "day",
                                tickLine: false,
                                axisLine: false,
                                tickMargin: 8,
                                tickFormatter: (d)=>d.slice(5)
                            }),
                            /*#__PURE__*/ _jsx(YAxis, {
                                tickLine: false,
                                axisLine: false,
                                width: 48,
                                tickFormatter: (v)=>formatTokens(v)
                            }),
                            /*#__PURE__*/ _jsx(ChartTooltip, {
                                content: /*#__PURE__*/ _jsx(ChartTooltipContent, {})
                            }),
                            /*#__PURE__*/ _jsx(ChartLegend, {
                                content: /*#__PURE__*/ _jsx(ChartLegendContent, {})
                            }),
                            /*#__PURE__*/ _jsx(Bar, {
                                dataKey: "prompt",
                                stackId: "tokens",
                                fill: "var(--color-prompt)",
                                stroke: "hsl(var(--background))",
                                strokeWidth: 1
                            }),
                            /*#__PURE__*/ _jsx(Bar, {
                                dataKey: "completion",
                                stackId: "tokens",
                                fill: "var(--color-completion)",
                                stroke: "hsl(var(--background))",
                                strokeWidth: 1,
                                radius: [
                                    4,
                                    4,
                                    0,
                                    0
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
